import { lazy, Suspense } from 'react'
import { ArrowLeft, Globe as GlobeIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

const FrontierGlobe = lazy(() => import('../components/FrontierGlobe'))

export default function FrontierGlobePage() {
  return (
    <div className="space-y-3 animate-fade-in">
      <div className="flex items-center gap-3 flex-wrap">
        <Link to="/app/frontier-models" className="text-text-muted hover:text-text-primary text-[11px] flex items-center gap-1">
          <ArrowLeft size={12} /> Frontier models
        </Link>
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-3">
            <GlobeIcon size={24} className="text-purple-light" /> Frontier Globe
          </h1>
          <p className="text-[11px] text-text-muted mt-0.5">
            Live arcs from frontier-lab HQs to news subjects · refreshes every 60s
          </p>
        </div>
      </div>
      <Suspense fallback={
        <div className="card flex items-center justify-center h-[640px] text-text-muted text-sm">
          Loading globe…
        </div>
      }>
        <div className="card p-0 overflow-hidden">
          <FrontierGlobe height={640} />
        </div>
      </Suspense>
    </div>
  )
}
